var map = {
	"./img/Klaas_profilePicture.jpg": "f0a1",
	"./img/arrow.svg": "1106",
	"./img/fdomes.jpg": "6023",
	"./img/gasgrill.jpg": "2309",
	"./img/zodiac.jpg": "7a12",
	"./logo.png": "cf05",
	"./logo.svg": "9b19"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";